import './stylesMarketplace.css';
import {useNavigate} from 'react-router-dom';
import {useSessionStore} from '../../hooks/useSessionStore';
import {UsuarioContext} from '../../contexts/UsuarioContext';
// import {makeStyles} from '@material-ui/core/styles';
import axios from 'axios';
import {Valoracion} from './Valoracion';
import 'bootstrap/dist/css/bootstrap.min.css';
import { useEffect, useState } from 'react';
import { useLocation } from 'react-router-dom';
import listaCategorias from './listadoCategorias.json';
import { ModalEmpresa } from './ModalEmpresa';

export const ListadoEmpresaBodyMarketplace = (props) => {
    const {empresa, rating} = props;

	const [sedes, setSedes] = useState([])
	const [categoriasEmpresa, setCategoriasEmpresa] = useState([])

	const {search} = useLocation();
	const query = new URLSearchParams(search)
	const [q, setQ] = useState('');
	const [lugar, setLugar] = useState('');

	const [showModal, setShowModal] = useState(false)

	useEffect(()=>{
		setQ(query.get('q'));
		setLugar(query.get('lugar'))
	},[search])

	useEffect(()=>{
		axios({
			method: 'get',
			url: window.ipdirection + 'sedePrestador/?idempresa='+ empresa.id,
		})
			.then((response) => {
				setSedes(response.data);
			})
			.catch((error) => {});

		axios({
			method: 'get',
			url: window.ipdirection + 'categoriaEmpresaCliente/?idempresa=' + empresa.id ,
			})
			.then((response) => {
				setCategoriasEmpresa((prevCategorias) => [...prevCategorias, response.data]);
			})
			.catch((error) => {});
	},[])



	/* A hook that allows to navigate between routes. */
	const navigate = useNavigate();
	const [Usuario, setUsuario] = useSessionStore(UsuarioContext);
	// const goToEmpresa = () => {
	// 	navigate('/perfilAgencia');
	// };
	// const useStyles = makeStyles({
	// 	root: {
	// 		'border-radius': 10,
	// 	},
	// });
	// const classes = useStyles();

	const abrirPerfilEmpresa = (id) => {
		if (Usuario.tipo === 'usuarioNormal') {
			axios({
				/* Sending a post request to the server. */
				method: 'post',
				url: window.ipdirection + 'logs?logstream=abrirPerfilEmpresa',
				headers: {
					Authorization: 'Bearer ' + Usuario.access,
				},
				data: {
					usuario: Usuario.cliente.usuario.id,
					idempresa: id,
					accion: 'abrirPerfilEmpresa',
				},
			})
				.then((response) => {})
				.catch((error) => {});
		}

		navigate('/perfilAgencia/' + id, 
			{state:{q:q,lugar:lugar}}
		);
	};
	const uniqueLocalidades = new Set();

    return(
		<>
			<div className='listadoEmpresa text-bg-light container-fluid' 
				onClick={() => {
					if (rating) {
						abrirPerfilEmpresa(empresa.id);
						}else{
							setShowModal(true)
						}
					}}
			>
				<div className='listadoImg'>
					<img className='img-thumbnail' src={empresa.img && empresa.img} alt={empresa.nombreEmpresa}/>
				</div>
				<div className='listadoComponent'>
					<div>
						<p className='empresa-title'>{empresa.nombreEmpresa}</p>
						<div>
							{
								sedes.map((sede, index) => {
									if (uniqueLocalidades.has(sede.localidad.nombre)) {
										return null;
									}
									uniqueLocalidades.add(sede.localidad.nombre);
										return (
										(sedes.length <= 1) ? (
											<small key={index} className='text-muted empresa-subtitulo'>{sede.localidad.nombre}</small>
										) : (index !== 0) ? (
											<span key={index} className='text-muted text-muted-span'>&#8226; <small className='text-muted empresa-subtitulo'>{sede.localidad.nombre}</small></span>
										) : (
											<small key={index} className='text-muted empresa-subtitulo'>{sede.localidad.nombre}</small>
										)
										);
									})
							}
							 {
								categoriasEmpresa &&
								categoriasEmpresa.map((categoria)=>(
									listaCategorias.map((color_categoria)=>(
										(categoria[0].empresa_id===empresa.id && categoria[0].categoria_id.nombre.toLowerCase() === color_categoria.nombre.toLowerCase()) ?
											<span className='text-muted text-muted-span'>&#8226;  <small className='text-muted empresa-subtitulo empresa-subtitulo-categoria' style={{backgroundColor:color_categoria.color}}>{categoria[0].categoria_id.nombre}</small></span>
										:<></>
									))
								))
							}
						</div>
						{empresa.distancia ?
							<span className='text-muted text-muted-span'>&#8226;  <small className='text-muted empresa-subtitulo'>{empresa.distancia}km</small></span>
							:<></>
						}
					</div>
					{(rating)?
						<div><Valoracion empresaId={empresa.id} /></div>
						:<div></div>
					}
				</div>
			</div>
			<ModalEmpresa empresa={empresa} categoriasEmpresa={categoriasEmpresa} showModal={showModal} setShowModal={setShowModal} />
		</>
    );
}